import { styled } from "@mui/material/styles";

export const HomePageContainer = styled("div")(() => ({
  marginTop: "120px",
  position: "relative",
  "@media only screen and (max-width: 768px)": {
    marginTop: "60px",
  },
}));
